/**
 * @description
 */
import request from '@/utils/request'

/**
 * @description 用户登录验证
 */
export function login(data) {
  return request({
    url: `/app/login/auth`,
    data,
    method: 'post'
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/app/login/out',
    method: 'post'
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/app/user/info',
    method: 'post'
  })
}

//修改个人资料
export function editAppUser(data) {
  return request({
    url: '/app/user/editAppUser',
    data,
    method: 'post'
  })
}

//获取验证码
export function sendValidateCode(params) {
  return request({
    url: '/app/user/sendValidateCode',
    params,
    method: 'get'
  })
}

//验证验证码
export function checkValidateCode(params) {
  return request({
    url: '/app/user/checkValidateCode',
    params,
    method: 'get'
  })
}

//修改密码
export function updatePassword(params) {
  return request({
    url: '/app/user/updatePassword',
    params,
    method: 'get'
  })
}

//关于我们
export function getLatestAboutUs(params) {
  return request({
    url: '/app/user/getLatestAboutUs',
    params,
    method: 'get'
  })
}

//修改手机号
export function updatePhone(params) {
  return request({
    url: '/app/user/updatePhone',
    params,
    method: 'get'
  })
}

/**
 * @description 更新关于我们信息
 * @param {Object} data 更新数据
 * @param {string} data.contactContent 联系我们文本内容
 * @param {string} data.textContent 关于我们文本内容
 * @param {number} data.id 记录ID
 */
export function updateAboutUs(data) {
  return request({
    url: '/app/user/editAboutUs',
    method: 'post',
    data
  })
}

//获取隐私政策协议
export function getLatestServiceAgreement(params) {
  return request({
    url: '/app/user/getLatestServiceAgreement',
    params,
    method: 'get'
  })
}
